import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationPipeModule } from '@ogs-gmbh/ngx-translate';

export type LegendItem = {
  variant: string;
  defaultText: string;
  token: string;
  scope?: string;
};
@Component({
  selector: 'app-legend',
  standalone: true,
  imports: [
    CommonModule,
    TranslationPipeModule
  ],
  templateUrl: './legend.component.html',
  styleUrl: './legend.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegendComponent {
  readonly items: InputSignal<LegendItem[]> = input<LegendItem[]>([]);
}
